// src/api/client.js
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  if (!response.ok) {
    const detail = await response.json().catch(() => ({}));
    throw new Error(detail.detail || `Request failed: ${response.status}`);
  }
  return response.status === 204 ? null : response.json();
}

// For file downloads (the export endpoint) -- same auth header as
// apiFetch, but no Content-Type (nothing's being sent) and returns a Blob
// instead of parsed JSON.
export async function apiFetchBlob(path, options = {}) {
  const token = localStorage.getItem("access_token");
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  if (!response.ok) {
    const detail = await response.json().catch(() => ({}));
    throw new Error(detail.detail || `Request failed: ${response.status}`);
  }
  return response.blob();
}

// For multipart file uploads (the import endpoint). Deliberately does NOT
// set Content-Type -- the browser has to set it itself (with the correct
// multipart boundary) when the body is a FormData, and setting it manually
// here would break that.
export async function apiFetchForm(path, formData, options = {}) {
  const token = localStorage.getItem("access_token");
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    ...options,
    headers,
    body: formData,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.detail || `Request failed: ${response.status}`);
  }
  return data;
}